import * as React from 'react';
import { Form, Button, Icon, Select, Col, DatePicker, Row } from 'antd';
import { FormComponentProps } from 'antd/lib/form/Form';
import bindAllOfThis from 'src/utils/BindThisHelper'; // 'this' binder
import { withLocalize, LocalizeContextProps } from 'react-localize-redux';
import ReportApiController from '../../api/ReportApiController';
import KeyValueDTO from '../../models/generic/KeyValueDTO';
import { downloadFile } from '../../utils/DownloadUtil';
import { LabeledValue, SelectValue } from 'antd/lib/select';
import PostedIntArray from '../../models/generic/PostedIntArray';



interface AdminReportProps extends FormComponentProps, LocalizeContextProps {
}

interface AdminReportState {
    isSubmitting: boolean;
    countries: KeyValueDTO<number,string>[];
    states: KeyValueDTO<number,string>[];
    districts: KeyValueDTO<number, string>[];
    schools: KeyValueDTO<number, string>[];
    selectedStateIds: number[];
    selectedCountryIds: number[];
    selectedDistrictIds: number[];
}

class AdminReport extends React.Component<AdminReportProps, AdminReportState> {
    constructor(props: AdminReportProps) {
        super(props);
        bindAllOfThis(this, AdminReport.prototype);

        this.state = {
            isSubmitting: false,
            countries: [],
            states: [],
            districts: [],
            schools: [],
            selectedCountryIds: [],
            selectedStateIds: [],
            selectedDistrictIds: []
        };
    }

    componentDidMount() {
        ReportApiController.getCountryHavingStates().then(response => {
            this.setState({ countries: response.data });
        });

        this.populateFiltersByCountryIds([]);
    }

    private populateFiltersByCountryIds(countryIds: number[]) {
        let dto: PostedIntArray = { listOfInts: countryIds };
        ReportApiController.filterByCountries(dto).then(response => {
            this.setState({
                selectedCountryIds: countryIds,
                states: response.data.states,
                districts: response.data.districts,
                schools: response.data.schools
            });
        });
    }

    private populateFiltersByStateIds(stateIds: number[]) {
        if (stateIds.length === 0) {
            this.populateFiltersByCountryIds(this.state.selectedCountryIds);
            return;
        }

        let dto: PostedIntArray = { listOfInts: stateIds };
        ReportApiController.filterByStates(dto).then(response => {
            this.setState({
                selectedStateIds: stateIds,
                districts: response.data.districts,
                schools: response.data.schools
            });
        });
    }

    private populateFiltersByDistrictIds(districtIds: number[]) {
        if (districtIds.length === 0) {
            this.populateFiltersByStateIds(this.state.selectedStateIds);
            return;
        }

        let dto: PostedIntArray = { listOfInts: districtIds };
        ReportApiController.filterByDistricts(dto).then(response => {
            this.setState({
                selectedDistrictIds: districtIds,
                schools: response.data
            });
        });
    }

    private countriesChange(e: SelectValue) {
        let selectedCountryIds: number[] = e as number[];
        this.populateFiltersByCountryIds(selectedCountryIds);
    }

    private statesChange(e: SelectValue) {
        let selectedStateIds: number[] = e as number[];
        this.populateFiltersByStateIds(selectedStateIds);
    }

    private districtsChage(e: SelectValue) {
        let selectedDistrictIds: number[] = e as number[];
        this.populateFiltersByDistrictIds(selectedDistrictIds);
    }

    private submit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();

        // Make sure all fields are valid
        this.props.form.validateFields((errors, values) => {
            // Loading for finish button
            this.setState({
                isSubmitting: !errors
            });

            ReportApiController.getAdminReport(values).then(response => {
                downloadFile(response.data.data, this.props.translate("report.admin.fileName").toString(), 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                this.setState({
                    isSubmitting: false
                });
            });
        });
    }

    private disabledStartDate(current: any) {
        var endDate = this.props.form.getFieldValue("toCreationDate");
        if (!current || !endDate) {
            return false;
        }

        return current.valueOf() >= endDate.valueOf();
    }

    private disabledEndDate(current: any) {
        var startDate = this.props.form.getFieldValue("fromCreationDate");
        if (!current || !startDate) {
            return false;
        }

        return current.valueOf() <= startDate.valueOf();
    }

    render() {
        return <Form layout="vertical" onSubmit={this.submit}>
            <Form.Item label={this.props.translate("report.admin.roleFilter.label").toString()}>
                {
                    this.props.form.getFieldDecorator("roleIds")
                        (<Select mode="multiple" placeholder={this.props.translate("report.admin.roleFilter.placeholder").toString()}>
                            <Select.Option value={1}>{this.props.translate("report.admin.roleFilter.KuderAdmin")}</Select.Option>
                            <Select.Option value={2}>{this.props.translate("report.admin.roleFilter.StateAdmin")}</Select.Option>
                            <Select.Option value={3}>{this.props.translate("report.admin.roleFilter.DistrictAdmin")}</Select.Option>
                            <Select.Option value={4}>{this.props.translate("report.admin.roleFilter.SchoolAdmin")}</Select.Option>
                            <Select.Option value={5}>{this.props.translate("report.admin.roleFilter.TeacherCounselorAdmin")}</Select.Option>
                        </Select>)
                }
            </Form.Item>
            <Row gutter={20}>
                <Col span={12}>
                    <Form.Item label={this.props.translate("common.from").toString()}>
                        {
                            this.props.form.getFieldDecorator("fromCreationDate")
                                (<DatePicker disabledDate={this.disabledStartDate} />)
                        }
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label={this.props.translate("common.to").toString()}>
                        {
                            this.props.form.getFieldDecorator("toCreationDate")
                                (<DatePicker disabledDate={this.disabledEndDate} />)
                        }
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={20}>
                <Col span={6}>
                    <Form.Item label={this.props.translate("report.admin.countryFilter.label").toString()}>
                        {
                            this.props.form.getFieldDecorator("countryIds")
                                (<Select
                                    filterOption={(input, option) => option.props.title.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    onChange={this.countriesChange}
                                    mode="multiple"
                                    placeholder={this.props.translate("report.admin.countryFilter.placeholder").toString()}>
                                    {
                                        this.state.countries &&
                                    this.state.countries.map(x => <Select.Option key={x.key.toString()} value={x.key} title={x.value}>{x.value}</Select.Option>)
                                    }
                                </Select>)
                        }
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item label={this.props.translate("report.admin.stateFilter.label").toString()}>
                        {
                            this.props.form.getFieldDecorator("stateIds")
                                (<Select
                                    filterOption={(input, option) => option.props.title.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    mode="multiple"
                                    onChange={this.statesChange}
                                    placeholder={this.props.translate("report.admin.stateFilter.placeholder").toString()}>
                                    {
                                        this.state.states &&
                                    this.state.states.map(x => <Select.Option key={x.key.toString()} value={x.key} title={x.value} > {x.value }</Select.Option>)
                                    }
                                </Select>)
                        }
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item label={this.props.translate("report.admin.districtFilter.label").toString()}>
                        {
                            this.props.form.getFieldDecorator("districtIds")
                                (<Select
                                    filterOption={(input, option) => option.props.title.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    onChange={this.districtsChage}
                                    mode="multiple"
                                    placeholder={this.props.translate("report.admin.districtFilter.placeholder").toString()}>
                                    {
                                        this.state.districts &&
                                        this.state.districts.map(x => <Select.Option key={x.key.toString()} value={x.key} title={x.value} >{x.value}</Select.Option>)
                                    }
                                </Select>)
                        }
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item label={this.props.translate("report.admin.schoolFilter.label").toString()}>
                        {
                            this.props.form.getFieldDecorator("schoolIds")
                                (<Select
                                    filterOption={(input, option) => option.props.title.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    mode="multiple" placeholder={this.props.translate("report.admin.schoolFilter.placeholder").toString()}>
                                    {
                                        this.state.schools &&
                                        this.state.schools.map(x => <Select.Option key={x.key.toString()} value={x.key} title={x.value}>{x.value}</Select.Option>)
                                    }
                                </Select>)
                        }
                    </Form.Item>
                </Col>
            </Row>
            <Button type="primary" icon="download" loading={this.state.isSubmitting} htmlType="submit">Download Report</Button>
        </Form>;
    }
}

export default withLocalize(Form.create()(AdminReport));



// WEBPACK FOOTER //
// ./src/components/admin/AdminReport.tsx